import { Routes, Route } from "react-router-dom";
import { Helmet } from "react-helmet";
import { Navigate } from "react-router";
import { ProfileCitizenshipViewContainer } from "../components/profile-citizenship-view.container";
import { ProfileCitizenshipEditContainer } from "../components/profile-citizenship-edit.container";

export const ProfileCitizenship: React.FC = () => {
  return (
    <div style={{width: "100%"}}>
      <Helmet>
        <title>Profile - Citizenship</title>
      </Helmet>
      <Routes>
        <Route index element={<Navigate to="view" replace />} />
        <Route path="view/*" element={<ProfileCitizenshipViewContainer />} />
        <Route path="edit/*" element={<ProfileCitizenshipEditContainer />} />
      </Routes>
    </div>
  );
};
